import {
    IconBillQueriesEuroRegular,
    IconMobileDeviceRegular,
    IconRouterRegular,
    IconTelephonePotRegular,
    IconTvContentRegular,
} from '@telefonica/mistica';

export const claimIconsMap = {
    Llamada: <IconTelephonePotRegular />,
    Mensaje: <IconMobileDeviceRegular />,
    Internet: <IconRouterRegular />,
    Contenidos: <IconTvContentRegular />,
    Cuota: <IconBillQueriesEuroRegular />,
};

export const claimsTag = ['Llamada', 'Mensaje', 'Internet', 'Contenidos', 'all'];
